import React, { useEffect, useState } from 'react';
import Logo from '../logo';
import { motion } from 'framer-motion';

interface LogoWidthDescriptionProps {
  data: {
    name: string;
    description: string;
    logo?: { url: string };
    padding: {
      mobile_top_padding: any;
      mobile_bottom_padding: any;
      desktop_top_padding: any;
      desktop_bottom_padding: any;
    };
  };
}

const ComponentSectionsLogoWidthDescription: React.FC<LogoWidthDescriptionProps> = ({ data }) => {
  // const page = data;
  const [top, setTop] = useState('');
  const [bottom, setBottom] = useState('');

  useEffect(() => {
    const updatePadding = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setTop(data.padding?.mobile_top_padding ?? '');
        setBottom(data.padding?.mobile_bottom_padding ?? '');
      } else {
        setTop(data.padding?.desktop_top_padding ?? '');
        setBottom(data.padding?.desktop_bottom_padding ?? '');
      }
    };

    updatePadding(); // Run on mount

    window.addEventListener('resize', updatePadding); // Listen on resize
    return () => window.removeEventListener('resize', updatePadding); // Clean up
  }, [data]);
  return (
    <>
      {/* <motion.h1
        className="text-start md:text-center flex md:justify-center font-light mb-16"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        {page.name}
      </motion.h1> */}

      <section>
        <div
          className="grid grid-cols-12 items-end pb-6 pt-[74px] md:pt-32"
          style={{
            paddingTop: `${top}rem`,
            paddingBottom: `${bottom}rem`,
          }}
        >
          <motion.div
            className="col-span-12 lg:col-span-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
          >
            <h2
              className="text-[24px] lg:text-[26px] font-light leading-7 lg:leading-8 lg:indent-16 sm:max-w-[460px] lg:max-w-[548px]"
              dangerouslySetInnerHTML={{
                __html: data?.description?.replace(/\n/g, '<br />') || '',
              }}
            />
          </motion.div>

          <motion.div
            className="lg:col-span-4 text-right hidden lg:block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut', delay: 0.4 }}
          >
            <div className="flex justify-end dynamiclogo">
              <Logo width={46.42} height={63.4} fillColor="#9E703E" />
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ComponentSectionsLogoWidthDescription;
